
import { TableConfig, DataTable } from "@app/interfaces";

export class ConductListTableConfig implements DataTable {

    constructor() { }

    static configure(): TableConfig {

        const tableConfig: TableConfig = {
            key: 'items',
            searchPanel: true,
            groupPanel: true,
            expandGroup: true,
            exportData: true,
            showPagination: {
                showPageSizeSelector: true,
                pageSize: 10,
                allowedPageSizes: [10, 25, 50, 100]
            },
            showHeaderFilter: true,
            fields: [
                {
                    caption: 'Broker Group',
                    dataField: 'brokerAdmin.brokerGroup.name'
                },
                {
                    caption: 'Broker Company',
                    dataField: 'brokerAdmin.user.firstName',
                    allowGrouping: true,
                },
                {
                    caption: 'Broker',
                    dataField: 'brokerName',
                    allowGrouping: true,
                },
                {
                    caption: 'Client',
                    dataField: 'clientName',
                    allowGrouping: true,
                },
                {
                    caption: 'Survey',
                    dataField: 'survey.name',
                    allowGrouping: true,
                },
                {
                    caption: 'Date Issued',
                    dataField: 'createdAt',
                    dataType: "date",
                    format: "dd MMM, yyyy",
                    allowGrouping: true,
                }
            ]
        };

        return tableConfig;

    }

}